/**
 * Fuente única de verdad para todo lo que sea URL canónica del sitio.
 *
 * El sitio responde tanto en greether.com como en www.greether.com, así que
 * cualquier URL que se le declare a un crawler (canonical, og:url, JSON-LD)
 * tiene que apuntar SIEMPRE al mismo host, o Google ve dos sitios duplicados.
 */
export const SITE_HOST = 'www.greether.com';
export const SITE_URL = `https://${SITE_HOST}`;
export const SITE_NAME = 'Greether';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/greether-logo.jpg`;

/** Convierte un path relativo en URL absoluta sobre el host canónico. */
export const absoluteUrl = (path = '/') => {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

/**
 * Normaliza un pathname a su forma canónica: sin query, sin hash y sin barra
 * final (salvo la raíz). Así /solo-female-travel/ y /solo-female-travel?utm=x
 * no se reportan como dos URLs distintas.
 */
export const canonicalUrlFor = (pathname: string) => {
  const [withoutHash] = pathname.split('#');
  const [path] = withoutHash.split('?');
  const trimmed = path.replace(/\/+$/, '');
  return absoluteUrl(trimmed || '/');
};

/**
 * Rutas públicas sin valor como resultado de búsqueda. Reciben `noindex` en
 * runtime desde SiteSeo.
 *
 * Hace falta declararlo acá aunque el HTML estático ya lo traiga: react-helmet
 * borra al hidratar los tags `data-rh` que ninguna instancia declara, así que
 * un `<meta name="robots">` puesto sólo en el HTML desaparece en cuanto React
 * monta — invisible para un crawler que ejecuta JS, que es justamente el que
 * decide si indexa.
 *
 * Se compara contra `noIndexRoutes` de scripts/seo-routes.mjs en `npm run
 * seo:check`, para que las dos listas no se separen.
 */
export const NOINDEX_PATHS = [
  '/booking-step-one',
  '/login',
  '/sign-up',
  '/greether-early-tester',
];

export const isNoIndexPath = (pathname: string) => {
  const [path] = pathname.split('?')[0].split('#');
  const normalized = path.replace(/\/+$/, '') || '/';
  return NOINDEX_PATHS.includes(normalized);
};
